import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import { v4 as uuidv4 } from "uuid";
import { RejaPendientes, armaBloque, cambiaCeldaBloques, llenaBloques, lineasCapturadas } from "../../../RejaPendientes";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import * as XLSX from "xlsx";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function EmbarquesCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_EMBARQUES = process.env.REACT_APP_URL_EMBARQUES;
  const URL_ARTICULOS_EMBARQUES = process.env.REACT_APP_URL_ARTICULOS_EMBARQUES;
  const URL_GASTOS_EMBARQUES = process.env.REACT_APP_URL_GASTOS_EMBARQUES;
  const URL_CONCEPTOS_GASTOS_EMBARQUES =
    process.env.REACT_APP_URL_CONCEPTOS_GASTOS_EMBARQUES;
  const URL_ARTICULOS_OC = process.env.REACT_APP_URL_ARTICULOS_OC;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;
  const URL_BROKERS = process.env.REACT_APP_URL_BROKERS;
  const URL_FORWARDERS = process.env.REACT_APP_URL_FORWARDERS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [fechaEmbarque, setFechaEmbarque] = useState(hoy);
  const [fechaEstimada, setFechaEstimada] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [tipoCambioUSDMXN, setTipoCambioUSDMXN] = useState(1);
  const [tipoCambioCNYUSD, setTipoCambioCNYUSD] = useState(1);
  // Costo en dolares segun la moneda de la orden: USD tal cual, CNY entre el tipo
  // de cambio CNY por USD y MXN entre el USD->MXN (antes todo lo que no era USD se
  // dividia entre el de CNY, y una orden en pesos quedaba mal costeada).
  const aUSD = (precio, moneda, tcCNY = tipoCambioCNYUSD, tcMXN = tipoCambioUSDMXN) => {
    const p = Number(precio) || 0;
    if (moneda === "CNY") return p / (parseFloat(tcCNY) || 1);
    if (moneda === "MXN") return p / (parseFloat(tcMXN) || 1);
    return p;
  };

  // ---- Captura en reja: se eligen OCs y se captura por color/talla lo que se
  // embarca de cada renglon pendiente. De la reja se derivan los inputFields
  // (un renglon por celda con cantidad) que usa el guardado de siempre. ----
  const [bloques, setBloques] = useState([]);
  const [provReja, setProvReja] = useState("");
  const [ocReja, setOcReja] = useState("");

  function agregaOC() {
    if (!ocReja) return;
    if (bloques.some((b) => b.key === ocReja)) {
      Swal.fire({ icon: "info", title: "Ya esta agregada", text: "Esa OC ya esta en la captura." });
      return;
    }
    const oc = OC.find((o) => o._id === ocReja);
    // el proveedor sale de la propia OC (el filtro de proveedor puede estar en "Todos")
    const provOC = oc?.proveedores?.[0]?._id || oc?.proveedores?.[0] || provReja;
    const lineas = articulosOC
      .filter((a) => a.ordenesCompra?.[0]?._id === ocReja && Number(a.pendiente_embarcar) > 0 && a.articulos?.[0])
      .map((a) => ({
        _id: a._id, articulo: a.articulos[0], color: a.colores?.[0] || null, talla: a.tallas?.[0] || null,
        pendiente: Number(a.pendiente_embarcar) || 0, cantidadOC: Number(a.cantidad) || 0,
        precio: Number(a.precio) || 0, moneda: a.ordenesCompra?.[0]?.moneda || "USD",
        OC: a.ordenesCompra?.[0]?._id, proveedor: provOC,
        piezasPorCaja: Number(a.articulos?.[0]?.piezasPorCaja) || 1,
      }));
    if (!lineas.length) {
      Swal.fire({ icon: "info", title: "Sin pendientes", text: "Esa OC no tiene piezas pendientes de embarcar." });
      return;
    }
    const prov = proveedores.find((p) => p._id === provOC);
    const nuevos = [...bloques, armaBloque(ocReja, `OC ${oc?.folioProveedor || oc?.idOrdenCompra || ""}`, `${prov?.nombre_comercial || ""} · ${oc?.moneda || "USD"}`, lineas)];
    setBloques(nuevos); sincroniza(nuevos); setOcReja("");
  }
  const cambiaReja = (bk, idA, idC, idT, v) => { const n = cambiaCeldaBloques(bloques, bk, idA, idC, idT, v); setBloques(n); sincroniza(n); };
  const llenaReja = (bk, idA, idC) => { const n = llenaBloques(bloques, bk, idA, true, idC); setBloques(n); sincroniza(n); };
  const limpiaReja = (bk, idA, idC) => { const n = llenaBloques(bloques, bk, idA, false, idC); setBloques(n); sincroniza(n); };
  const quitaReja = (bk) => { const n = bloques.filter((b) => b.key !== bk); setBloques(n); sincroniza(n); };

  // Deriva inputFields, total y agrupado por proveedor a partir de la reja
  function sincroniza(lista) {
    const filas = lineasCapturadas(lista).map(({ linea, cantidad }) => {
      const costoUSD = aUSD(linea.precio, linea.moneda);
      return {
        id: uuidv4(), articulosOrden: linea._id, OC: linea.OC, proveedorOrden: linea.proveedor,
        articulos: linea.articulo._id, colores: linea.color?._id || "", tallas: linea.talla?._id || "",
        cantidad, cantidadOC: linea.cantidadOC, costo: linea.precio, costoUSD,
        costoTotal: costoUSD * cantidad, piezasPorCaja: linea.piezasPorCaja,
        cajas: cantidad / (linea.piezasPorCaja || 1), moneda: linea.moneda,
      };
    });
    setInputFields(filas);
    setTotalCantidad(filas.reduce((t, f) => t + f.cantidad, 0));
    const ag = filas.reduce((g, f) => {
      g[f.proveedorOrden] = g[f.proveedorOrden] || { proveedorOrden: f.proveedorOrden, costoTotal: 0, cantidad: 0 };
      g[f.proveedorOrden].costoTotal += f.costoTotal;
      g[f.proveedorOrden].cantidad += f.cantidad;
      return g;
    }, {});
    setAgrupado(Object.values(ag));
  }
  // Si cambia el tipo de cambio CNY->USD se recalculan los costos en USD
  useEffect(() => { if (bloques.length) sincroniza(bloques); }, [tipoCambioCNYUSD, tipoCambioUSDMXN]); // eslint-disable-line

  const [articulosOC, setArticulosOC] = useState([]);
  const [OC, setOC] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [contenedor, setContenedor] = useState("");
  const [totalCaptura, setTotalCaptura] = useState(1);
  const [proveedores, setProveedores] = useState([]);
  const [brokers, setBrokers] = useState([]);
  const [selectedBroker, setSelectedBroker] = useState("");
  const [forwarders, setForwarders] = useState([]);
  const [selectedForwarder, setSelectedForwarder] = useState("");
  const [agrupado, setAgrupado] = useState([]);
  const [bultos, setBultos] = useState(0);
  const [noFactura, setNoFactura] = useState("0");

  const [conceptosGastos, setConceptosGastos] = useState("");

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      colores: "",
      tallas: "",
      articulosOrden: "",
      articulos: "",
      cantidad: 0,
      piezasPorCaja: 0,
      cajas: 0,
      cantidadOC: 0,
      costo: 0,
      costoUSD: 0,
      costoTotal: 0,
      proveedorOrden: "",
      moneda:"",
      OC:""
    },
  ]);
  const [coloresCat, setColoresCat] = useState([]);
  const [tallasCat, setTallasCat] = useState([]);

  const [validaBoton, setValidaBoton] = useState(true);


  useEffect(() => {
    axios
      .get(process.env.REACT_APP_URL_COLORES, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setColoresCat(res.data.filter((a) => a.is_active === "Si")))
      .catch((err) => console.log(err));
    axios
      .get(process.env.REACT_APP_URL_TALLAS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setTallasCat(res.data.filter((a) => a.is_active === "Si")))
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    axios
      .get(URL_ARTICULOS_OC, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulosOC = res.data;
        setArticulosOC(allArticulosOC);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_BROKERS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allBrokers = res.data;
        setBrokers(allBrokers);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_FORWARDERS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setForwarders(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_CONCEPTOS_GASTOS_EMBARQUES}Fijos`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allConceptosGastos = res.data;
        setConceptosGastos(allConceptosGastos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
    .get(`${URL_PROVEEDORES}`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_ORDENES_COMPRA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allOC = res.data;
        setOC(allOC);
      })
      .catch((err) => {
        console.log(err);
      });

  }, []);

  // Guarda el embarque. Puede llevar varias OC de varios proveedores: una nota
  // de cuentas por pagar por proveedor con sus renglones. Va paso por paso
  // (antes lanzaba todo a la vez con un contador que, con dos o mas
  // proveedores, llegaba a cero antes de tiempo y recargaba la pagina dejando
  // el embarque a medias).
  const saveEmbarqueNuevo = async (event) => {
    event.preventDefault();
    const faltan = [];
    if (!fechaEmbarque) faltan.push("fecha de embarque");
    if (!fechaEstimada) faltan.push("ETA de arribo");
    if (!contenedor) faltan.push("contenedor");
    if (!observaciones) faltan.push("observaciones");
    if (!inputFields.length) faltan.push("piezas a embarcar");
    if (faltan.length) {
      Swal.fire({ icon: "warning", title: "Faltan datos", text: `Captura: ${faltan.join(", ")}.` });
      return;
    }
    const nombreProv = (id) => proveedores.find((p) => p._id === id)?.nombre_comercial || "Proveedor";
    const fmt = (n) => new Intl.NumberFormat("en-US").format(Number(n) || 0);
    const ocs = new Set(inputFields.map((f) => f.OC)).size;
    const result = await Swal.fire({
      title: "¿Guardar el embarque?",
      html: `${fmt(total_cantidad)} piezas de ${ocs} OC · ${agrupado.length} proveedor(es)<br><br>` +
        agrupado.map((b) => `${nombreProv(b.proveedorOrden)}: ${fmt(b.cantidad)} pzas · $${fmt(b.costoTotal.toFixed(2))} USD`).join("<br>"),
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Si, guardar",
      cancelButtonText: "Cancelar",
    });
    if (!result.isConfirmed) return;

    setValidaBoton(false);
    setModalProgreso(true);
    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    const TTC = inputFields.reduce((t, c) => t + (parseFloat(c.costoTotal) || 0), 0);
    try {
      const { data: emb } = await axios.post(URL_EMBARQUES, {
        fechaEmbarque, fechaEstimada, observaciones, contenedor, total_cantidad,
        recibido: "No",
        total_costo: parseFloat(TTC).toFixed(2), saldo: parseFloat(TTC).toFixed(2),
        creado: user.id,
        // son opcionales: vacios, el back los rechaza
        ...(selectedBroker ? { brokers: selectedBroker } : {}),
        ...(selectedForwarder ? { forwarders: selectedForwarder } : {}),
        total_gasto: 0, tipoCambioUSDMXN, tipoCambioCNYUSD, bultos, noFactura,
      }, { headers });

      // una nota de cuentas por pagar por proveedor, con sus renglones
      for (const b of agrupado) {
        const { data: nota } = await axios.post(URL_NOTAS_CXP, {
          proveedores: b.proveedorOrden, embarques: emb._id,
          total_cantidad: b.cantidad,
          total_costo: parseFloat(b.costoTotal).toFixed(2), saldo: parseFloat(b.costoTotal).toFixed(2),
          calidad: "No", fecha: fechaEmbarque, compraDirecta: "No",
        }, { headers });
        for (const a of inputFields.filter((f) => f.articulos && Number(f.cantidad) > 0 && f.proveedorOrden === b.proveedorOrden)) {
          await axios.post(URL_ARTICULOS_EMBARQUES, {
            articulosOC: a.articulosOrden, articulos: a.articulos, colores: a.colores, tallas: a.tallas,
            cantidad: a.cantidad, recibido: 0, pendiente_recibir: a.cantidad,
            embarques: emb._id, notasCxP: nota._id,
            costo: a.costo, total_costo: a.costoTotal, proveedores: a.proveedorOrden,
            faltante: 0, danado: 0, impuestos: 0, revisarFaltante: 10, revisarDanado: 10,
            pedirFaltante: 0, pedirDanado: 10, faltanteTotal: 0, danadoTotal: 0,
            descuentoFaltante: 0, descuentoDanado: 0, descuentoTotal: 0,
            familias: "NA", sup: "NA", observaciones: "NA", calidad: "No",
            costoUSD: a.costoUSD,
          }, { headers });
        }
      }

      // lo embarcado se descuenta de cada OC
      for (const w of inputFields) {
        await axios.patch(`${URL_ARTICULOS_OC}editEmbarcado/${w.articulosOrden}`,
          { embarcado: w.cantidad, ordenesCompra: w.OC }, { headers });
      }

      for (const w of conceptosGastos || []) {
        await axios.post(URL_GASTOS_EMBARQUES, {
          conceptosGastosEmbarques: w._id, estimado: w.estimado, real: w.estimado, embarques: emb._id,
        }, { headers });
      }

      await axios.post(URL_LOGS, {
        tipo: "Crear Embarque",
        detalle: `Fecha Embarque ${fechaEmbarque} / Contenedor ${contenedor} / ${ocs} OC / ${agrupado.length} proveedor(es)`,
        user: user.id,
      }, { headers }).catch(() => {});
      setModalProgreso(false);
      await Swal.fire({ icon: "success", title: `Embarque ${emb.idEmbarques || ""} creado`, timer: 1500, showConfirmButton: false });
      window.location.reload();
    } catch (error) {
      setModalProgreso(false);
      setValidaBoton(true);
      Swal.fire({
        icon: "error", title: "No se pudo guardar el embarque",
        text: error.response?.data?.message || error.message,
        footer: "Lo que alcanzo a guardarse ya quedo; revisa el listado de embarques antes de volver a guardar.",
      });
    }
  };

  
  const handleAddFields = () => {
    let TC = totalCaptura + 1;
    const ultimo = inputFields[inputFields.length - 1];

    setTotalCaptura(TC);
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        colores: "",
        tallas: "",
        articulosOrden: "",
        articulos: "",
        cantidad: 0,
        piezasPorCaja: 0,
        cajas: 0,
        cantidadOC: 0,
        costo: 0,
        costoUSD: 0,
        costoTotal: 0,
        proveedorOrden: "",
        ordenCompra: "",
        moneda:"",
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let cant = values.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);

    let agrupado = values.reduce(function (groups, item) {
      const val = item["proveedorOrden"];
      groups[val] = groups[val] || {
        proveedorOrden: item.proveedorOrden,
        costoTotal: 0,
        cantidad: 0,
      };
      groups[val].proveedorOrden = item.proveedorOrden;
      groups[val].costoTotal += item.costoTotal;
      groups[val].cantidad += item.cantidad;
      return groups;
    }, []);
    let temp = Object.values(agrupado)
 setAgrupado(temp)
  };

  // const handleChangeInput = (id, event) => {
  //   const newInputFields = inputFields.map((i) => {
  //     if (id === i.id) {
  //       i[event.target.name] = event.target.value;
  //       i.costoTotal = parseFloat(event.target.value) * parseFloat(i.costo);
  //     }
  //     return i;
  //   });
  //   setInputFields(newInputFields);
  //   ActualizaTotales();
  // };

  function BuscaProveedor(id, event) {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.proveedorOrden = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
  }
  function BuscaOC(id, event) {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.OC = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
  }


  function BuscaOrden(id, event) {
    articulosOC.map((a) => {
      if (a._id == event.target.value) {
        if(a.ordenesCompra?.[0]?.moneda == "USD"){
          let articulosOrden = event.target.value;
          let cantidadOC = a.cantidad;
          let costo = a.precio
          let costoUSD = a.precio
          let articulo = a.articulos?.[0]?._id
          let piezasPorCaja = a.articulos?.[0]?.piezasPorCaja
          let moneda = a.ordenesCompra?.[0]?.moneda
          handleChangeInputOC(id, articulosOrden, cantidadOC, costo, costoUSD, articulo, piezasPorCaja, moneda);
        }else{
          let articulosOrden = event.target.value;
          let cantidadOC = a.cantidad;
          let costo = a.precio
          let costoUSD = aUSD(a.precio, a.ordenesCompra?.[0]?.moneda)
          let articulo = a.articulos?.[0]?._id
          let piezasPorCaja = a.articulos?.[0]?.piezasPorCaja
          let moneda = a.ordenesCompra?.[0]?.moneda
          handleChangeInputOC(id, articulosOrden, cantidadOC, costo, costoUSD, articulo, piezasPorCaja, moneda);
        }
        
      }
    });
  }
  const handleChangeInputOC = (id, articulosOrden, cantidadOC, costo, costoUSD, articulo, piezasPorCaja, moneda) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulosOrden = articulosOrden;
        i.cantidadOC = cantidadOC;
        i.costo = costo;
        i.costoUSD = costoUSD;
        i.costoTotal = parseFloat(costoUSD) * parseFloat(i.cantidad);
        i.articulos = articulo;
        i.piezasPorCaja = piezasPorCaja;
        i.moneda = moneda;
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  function ActualizaTotales() {
    let cant = inputFields.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);

    let agrupado = inputFields.reduce(function (groups, item) {
      const val = item["proveedorOrden"];
      groups[val] = groups[val] || {
        proveedorOrden: item.proveedorOrden,
        costoTotal: 0,
        cantidad: 0,
      };
      groups[val].proveedorOrden = item.proveedorOrden;
      groups[val].costoTotal += item.costoTotal;
      groups[val].cantidad += item.cantidad;
      return groups;
    }, []);
    let temp = Object.values(agrupado)
 setAgrupado(temp)
  }

  // Verificar cantidad

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
        i.cajas = parseFloat(event.target.value) / parseFloat(i.piezasPorCaja);
        i.costoTotal = parseFloat(event.target.value) * parseFloat(i.costoUSD);
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidadCajas = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        let cantTemp =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        i[event.target.name] = event.target.value;
        i.cantidad =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        i.costoTotal =
          parseFloat(event.target.value) *
          parseFloat(i.piezasPorCaja) *
          parseFloat(i.costoUSD);
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };



  //   function importarArchivo(event){
  //   const target = event.target;
  //   const value = target.type === "checkbox" ? target.checked : target.value;
  //   const name = target.name;
  //   let hojas = [];
   
  //   if (name === "file") {
  
  //     let reader = new FileReader();
  //       reader.readAsArrayBuffer(target.files[0]);
  //       reader.onloadend = (e) => {
  //         var data = new Uint8Array(e.target.result);
  //         var workbook = XLSX.read(data, { type: "array" });
  
  //         workbook.SheetNames.forEach(function (sheetName) {
  //           // Here is your object
  //           var XL_row_object = XLSX.utils.sheet_to_json(
  //             workbook.Sheets[sheetName]
  //           );
  //           hojas.push({
  //             data: XL_row_object,
  //             sheetName,
  //           });
  //         });
  
  //         let A1 = hojas[0].data
  
  //         let TC = totalCaptura
  //         A1.map((a)=>{
  //            TC = TC + 1
  //           setTotalCaptura(TC)
  //         inputFields.push({
  //           id: uuidv4(),
  //           articulosOrden: a.articulosOrden,
  //           articulos: a.articulos,
  //           cantidad: a.cantidad,
  //           piezasPorCaja: 0,
  //           cajas: 0,
  //           cantidadOC: a.cantidad,
  //           costo: a.costo,
  //           costoUSD: a.costo,
  //           moneda:"USD",
  //           costoTotal: (a.costo * a.cantidad).toFixed(2),
  //           proveedorOrden: "661def0dcaa8074ee9768e4b",
  //           OC: "661df163caa8074ee9768f75"
  //         })
  //         })
  
  //         ActualizaTotales()
  //       }
  //   }
  // }
  // console.log("hola", inputFields)

  return (
    <>
      <Header />
      <br />
      <br />
      {user.embarques ? (
        <div className="card container col-10">
          <h3 align="center">Nuevo Embarque</h3>
          <Form onSubmit={saveEmbarqueNuevo}>
            <Row>
              <Col md={2}>
                <Label>Fecha Embarque</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaEmbarque}
                  required
                  onChange={(e) => {
                    setFechaEmbarque(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Agente Aduanal</Label>
                    <Input
                      name="Broker"
                      type="select"
                      value={selectedBroker}
                      required
                      onChange={(event) => {
                        setSelectedBroker(event.target.value);
                      }}
                    >
                      <option value="">Selecciona un Agente Aduanal</option>
                      {brokers
                        .sort((a, b) =>
                        a.name > b.name ? 1 : -1
                      )
                      .map((a) => {
                          return (
                            <option value={a._id}>{a.name}</option>
                          );
                      })}
                    </Input>
                  </Col>
              <Col md={2}>
                <Label>Forwarder</Label>
                    <Input
                      name="Forwarder"
                      type="select"
                      value={selectedForwarder}
                      onChange={(event) => {
                        setSelectedForwarder(event.target.value);
                      }}
                    >
                      <option value="">Selecciona un Forwarder</option>
                      {forwarders
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col>
              <Col md={2}>
                <Label># Contenedor</Label>
                <Input
                  type="text"
                  placeholder="contenedor"
                  value={contenedor}
                  required
                  onChange={(e) => {
                    setContenedor(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>ETA de Arribo</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaEstimada}
                  required
                  onChange={(e) => {
                    setFechaEstimada(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Bultos
                </Label>
                <Input
                  type="number"
                  value={bultos}
                  required
                  onChange={(e) => {
                    setBultos(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  No. Factura
                </Label>
                <Input
                  type="text"
                  placeholder="NoFactura"
                  value={noFactura}
                  required
                  onChange={(e) => {
                    setNoFactura(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  TIpo Cambio CNY USD
                </Label>
                <Input
                  type="number"
                  placeholder="tipoCambioCNYUSD"
                  value={tipoCambioCNYUSD}
                  required
                  onChange={(e) => {
                    setTipoCambioCNYUSD(e.target.value);
                    const newInputFields = inputFields.map((i) => {
                      if(i.moneda == 'CNY'){
                        i.costo = i.costo
                        i.costoUSD = i.costo / e.target.value
                        i.costoTotal = parseFloat(i.costo / e.target.value) * parseFloat(i.cantidad);
                        }
                      return i;
                    });
                    setInputFields(newInputFields);
                    ActualizaTotales()
                  }}
                />
              </Col>
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  TIpo Cambio USD MXN
                </Label>
                <Input
                  type="number"
                  placeholder="tipoCambioUSDMXN"
                  value={tipoCambioUSDMXN}
                  required
                  onChange={(e) => {
                    setTipoCambioUSDMXN(e.target.value);
                    // las ordenes en pesos se recalculan con el nuevo tipo de cambio
                    const tc = e.target.value;
                    const newInputFields = inputFields.map((i) => {
                      if (i.moneda == "MXN") {
                        i.costoUSD = aUSD(i.costo, "MXN", tipoCambioCNYUSD, tc);
                        i.costoTotal = i.costoUSD * parseFloat(i.cantidad);
                      }
                      return i;
                    });
                    setInputFields(newInputFields);
                    ActualizaTotales()
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES{" "}
                  {new Intl.NumberFormat("en-US").format(total_cantidad)} pzas.
                </h4>
              </Col>
            </Row>

                 {/* <Row>

            <Col>
                    <Input
                      required
                      type="file"
                      name="file"
                      id="file"
                      onChange={(event) =>
                        importarArchivo(event)
                      }
                    />
                    </Col>
            </Row> */}

            {/* Tabla Articulos: captura en reja por OC */}
            <Row className="mb-2">
              <Col md={3}>
                <Label className="mr-sm-2">Proveedor (opcional, filtra las PO)</Label>
                <Input bsSize="sm" type="select" value={provReja} onChange={(e) => { setProvReja(e.target.value); setOcReja(""); }}>
                  <option value="">Todos</option>
                  {proveedores.slice().sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1)).map((a) => (
                    <option key={a._id} value={a._id}>{a.nombre_comercial}</option>
                  ))}
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">PO</Label>
                {/* Sin proveedor elegido salen las OC abiertas de todos (con su proveedor):
                    un embarque puede llevar OC de varios proveedores */}
                <Input bsSize="sm" type="select" value={ocReja} onChange={(e) => setOcReja(e.target.value)}>
                  <option value="">Selecciona</option>
                  {OC.filter((o) => o.status === "Abierto" && (!provReja || o.proveedores?.[0]?._id === provReja) && !bloques.some((b) => b.key === o._id))
                    .map((o) => ({ o, pend: articulosOC.filter((a) => a.ordenesCompra?.[0]?._id === o._id).reduce((t, a) => t + (Number(a.pendiente_embarcar) || 0), 0) }))
                    .filter(({ pend }) => pend > 0)
                    .sort((a, b) => ((a.o.proveedores?.[0]?.nombre_comercial || "") + (a.o.folioProveedor || a.o.idOrdenCompra) > (b.o.proveedores?.[0]?.nombre_comercial || "") + (b.o.folioProveedor || b.o.idOrdenCompra) ? 1 : -1))
                    .map(({ o, pend }) => (
                      <option key={o._id} value={o._id}>
                        {o.folioProveedor || o.idOrdenCompra}{provReja ? "" : ` · ${o.proveedores?.[0]?.nombre_comercial || ""}`} · {o.moneda || "USD"} · pend. {new Intl.NumberFormat("en-US").format(pend)} pzas
                      </option>
                    ))}
                </Input>
              </Col>
              <Col md={2} style={{ display: "flex", alignItems: "flex-end" }}>
                <Button size="sm" color="success" onClick={agregaOC} disabled={!ocReja}>
                  <i className="fas fa-plus" /> Agregar PO
                </Button>
              </Col>
            </Row>
            <RejaPendientes
              bloques={bloques}
              onCambia={cambiaReja}
              onLlenar={llenaReja}
              onLimpiar={limpiaReja}
              onQuitar={quitaReja}
              etiquetaPendiente="Pend."
            />
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES{" "}
                  {new Intl.NumberFormat("en-US").format(total_cantidad)} pzas.
                </h4>
              </Col>
            </Row>
            {/* Termina Tabla Articulos */}

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoEmbarques"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default EmbarquesCreate;
